import React, { useState, useEffect } from 'react';

//Import Componentsimport { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ChartPie from '../charts/Chartjs/pie';
import BarChart1 from '../charts/Chartjs/bar1';
import { MdWorkHistory } from 'react-icons/md';
import { BiTrip } from 'react-icons/bi';
import 'react-calendar/dist/Calendar.css';
import { MdOutlineSyncProblem } from 'react-icons/md';
import ReactStars from 'react-stars';
import ManageBookingModal from './ManageBookingModal';
import { fetchDashboardStats } from '../../services/dashboardServices';
import { fetchRequests, updateRequestStatus } from '../../services/requestServices';
import { getEmployeeFeedback } from '../../services/feedbackServices';
import { fetchProfile } from '../../services/authServices';
import { getAssignedBookings } from '../../services/bookingServices';
import { Tab, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTimesCircle, FaClock, FaPauseCircle, FaExclamationTriangle, FaUndo } from 'react-icons/fa';
import moment from 'moment';

export const LeaveMapping = {
  Sick: 'sickLeaves',
  Paid: 'paidLeaves',
  Casual: 'casualLeaves',
};

const Dashboard = () => {
  const [packages, setPackages] = useState({
    totalPackages: [],
    assignedPackages: [],
  });
  const [showBookingModal, setShowBookingModal] = useState(false);

  const handleShowBookingModal = () => setShowBookingModal(true);
  const handleCloseBookingModal = () => setShowBookingModal(false);

  const [currentMonth, setCurrentMonth] = useState(new Date());

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Bookings Chart',
        data: Array(12).fill(0), // Initialize with 12 zeros
        borderColor: 'rgba(226, 52, 40, 1)',
        borderWidth: 1,
        backgroundColor: 'rgba(226, 52, 40, 1)',
        barThickness: 20,
      },
    ],
  });
  const [todaysRequests, setTodaysRequests] = useState([]);
  const [recentFeedback, setRecentFeedback] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const [totalEntries, setTotalEntries] = useState(0);

  // ✅ Fetch feedback on component mount
  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const response = await getEmployeeFeedback();
        setRecentFeedback(response.feedbacks); // Assuming API returns { feedbacks: [...] }
      } catch (error) {
        console.error('Error fetching feedback:', error);
      }
    };

    fetchFeedback();
  }, []);
  useEffect(() => {
    fetchBookings();
  }, [page]);

  const fetchBookings = async () => {
    try {
      const result = await getAssignedBookings(page, limit);
      setBookings(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalEntries(result.pagination.totalRecords);
    } catch (error) {
      console.error('Error loading bookings:', error);
    }
  };

  const handleRequests = async () => {
    try {
      const response = await fetchRequests();

      setTodaysRequests(response.requests);
    } catch (error) {
      console.error('Error fetching employee requests:', error);
    }
  };
  const handleRequestStatus = async (requestId, newStatus) => {
    try {
      const updatedRequest = await updateRequestStatus(requestId, newStatus);

      // Update UI with new status
      setTodaysRequests((prevRequests) =>
        prevRequests.map((request) => (request._id === requestId ? { ...request, status: newStatus } : request))
      );

      alert(`Request ${newStatus} successfully!`);
    } catch (error) {
      alert('Failed to update request status.');
    }
  };
  useEffect(() => {
    handleRequests();
  }, []);
  // Function to transform `monthlyBookings`
  const transformMonthlyBookings = (monthlyBookings) => {
    const monthlyData = Array(12).fill(0); // Start with 12 months, all 0

    // Map API response into correct month slots
    monthlyBookings?.forEach((entry) => {
      if (entry._id >= 1 && entry._id <= 12) {
        monthlyData[entry._id - 1] = entry.count; // `_id` is the month number
      }
    });

    return monthlyData;
  };

  const getStats = async () => {
    try {
      const data = await fetchDashboardStats();

      setStats(data);

      // Extract & transform `monthlyBookings` from stats
      if (data?.monthlyBookings) {
        const updatedData = transformMonthlyBookings(data.monthlyBookings);
        setBookingDetails((prev) => ({
          ...prev,
          datasets: [{ ...prev.datasets[0], data: updatedData }],
        }));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch stats on mount
  useEffect(() => {
    getStats();
  }, []);

  useEffect(() => {
    const handleProfile = async () => {
      const res = await fetchProfile();

      if (res?.employee) {
        localStorage.setItem('employee', JSON.stringify(res?.employee));
      }
    };

    handleProfile();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  // const recentFeedback = [
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4.2,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 3.7,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 5,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 2.9,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  //   {
  //     customerName: 'John Doe',
  //     packageName: 'Dubai Tour',
  //     feedback: 4,
  //   },
  // ];
  // Dummy data for bookings
  const dummyBookings = [
    {
      id: 1,
      customerName: 'John Doe',
      bookingDate: '2024-12-15',
      packageName: 'Himalayan Adventure',
      status: 'Confirmed',
    },
    {
      id: 2,
      customerName: 'Jane Smith',
      bookingDate: '2024-12-20',
      packageName: 'Beach Paradise',
      status: 'Pending',
    },
    {
      id: 3,
      customerName: 'Michael Lee',
      bookingDate: '2024-12-18',
      packageName: 'City Explorer',
      status: 'Confirmed',
    },
  ];

  const sampleRequests = [
    {
      id: 1,
      customerName: 'Alice Johnson',
      details: 'Need a car for sightseeing during the trip.',
      serviceDate: new Date().toISOString(), // Current date
    },
    {
      id: 2,
      customerName: 'Bob Smith',
      details: 'Require an extra room for 2 guests.',
      serviceDate: '2024-12-20T00:00:00.000Z', // Not today's date
    },
  ];

  const currentDay = new Date().toDateString();

  // Filter requests for the current day
  // const todaysRequests = sampleRequests.filter(
  //   (request) => new Date(request.serviceDate).toDateString() === currentDay
  // );

  const handleAction = (requestId, action) => {
    // Placeholder for handling actions like "Approve" or "Reject"
    console.log(`Action: ${action} for Request ID: ${requestId}`);
  };
  const renderStatusBadge = (status) => {
    const badgeStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      // width:"150px",
      // minWidth: "50px", // Ensures all badges are of the same size
      // padding: "0.5rem 0.5rem", // Adjust padding for better alignment,
      fontSize: '12px',
    };
    switch (status) {
      case 'Pending':
        return (
          <Badge bg="secondary" style={badgeStyle}>
            Pending <FaClock />
          </Badge>
        );
      case 'Processing':
        return (
          <Badge bg="info" style={badgeStyle}>
            Processing <FaPauseCircle />
          </Badge>
        );
      case 'Open':
        return (
          <Badge bg="success" style={badgeStyle}>
            Open <FaCheckCircle />
          </Badge>
        );
      case 'Completed':
        return (
          <Badge bg="success" style={badgeStyle}>
            Completed <FaCheckCircle />
          </Badge>
        );
      case 'Confirmed':
        return (
          <Badge bg="success" style={badgeStyle}>
            Confirmed <FaCheckCircle />
          </Badge>
        );
      case 'On Hold':
        return (
          <Badge bg="warning" style={badgeStyle}>
            On Hold <FaExclamationTriangle />
          </Badge>
        );
      case 'Cancelled':
        return (
          <Badge bg="danger" style={badgeStyle}>
            Cancelled <FaTimesCircle />
          </Badge>
        );
      case 'Refund Initiated':
        return (
          <Badge bg="primary" style={badgeStyle}>
            Refund Initiated <FaUndo />
          </Badge>
        );
      case 'Refund Completed':
        return (
          <Badge bg="success" style={badgeStyle}>
            Refund Completed <FaCheckCircle />
          </Badge>
        );
      // default:
      //   return (
      //     <Badge bg="dark" style={badgeStyle}>
      //       Unknown <FaExclamationTriangle />
      //     </Badge>
      //   );
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-xl-4 col-md-6">
                    <div className="card booking">
                      <div className="card-body">
                        <div className="booking-status d-flex align-items-center">
                          <div className="px-2 font-normal flex flex-row gap-x-3 text-base">
                            <p className="text-4xl my-auto ">
                              <MdWorkHistory />
                            </p>
                            <div className="flex flex-col">
                              <p className="mb-0 text-nowrap">
                                <strong>Total Assigned Queries:</strong> {stats?.totalAdmissionInquiries || 0}
                              </p>
                              <p className="mb-0 text-nowrap">
                                <strong>Total Pending Queries:</strong> {stats?.pendingAdmissionInquiries || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-md-6">
                    <div className="card booking">
                      <div className="card-body">
                        <div className="booking-status d-flex align-items-center">
                          <div className="px-2 font-normal flex flex-row gap-x-3 text-base">
                            <p className="text-4xl my-auto ">
                              <BiTrip />
                            </p>
                            <div className="flex flex-col">
                              <p className="mb-0 text-nowrap">
                                <strong>Total Hotel & Tour:</strong>{' '}
                                {stats?.totalHotelBookings + stats?.totalTourBookings || 0}
                              </p>
                              <p className="mb-0 text-nowrap">
                                <strong>Total Hotel & Tour Pending:</strong>{' '}
                                {stats?.pendingHotelBookings + stats?.pendingTourBookings || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-md-6">
                    <div className="card booking">
                      <div className="card-body">
                        <div className="booking-status d-flex align-items-center">
                          <div className="px-2 font-normal flex flex-row gap-x-3 text-base">
                            <p className="text-4xl my-auto ">
                              <MdOutlineSyncProblem />
                            </p>
                            <div className="flex flex-col">
                              <p className="mb-0 text-nowrap">
                                <strong>Total Flight Booking:</strong> {stats?.totalFlightBookings || 0}
                              </p>
                              <p className="mb-0 text-nowrap">
                                <strong>Total Flight Booking Pending:</strong> {stats?.pendingFlightBookings || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="card booking">
                      <div
                        className="card-body"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                        }}
                      >
                        <p className="fs-4 fw-bold" style={{ width: '100%' }}>
                          Customer Requests for {currentDay}
                        </p>

                        <div className="mt-3">
                          {todaysRequests.length > 0 ? (
                            <ul className="list-group">
                              {todaysRequests.map((request) => (
                                <li
                                  key={request._id} // Use _id instead of id if MongoDB
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                  <div>
                                    <p className="mb-1 fw-bold">{request.user?.name || 'Unknown User'}</p>
                                    <small>{request?.description || 'No details available'}</small>
                                    <p className="text-muted mb-0">
                                      Service Date: {new Date(request.requestDate).toLocaleDateString()}
                                    </p>
                                  </div>
                                  <div>
                                    {request.status === 'Pending' ? (
                                      <>
                                        <button
                                          className="btn btn-sm btn-success me-2 text-black"
                                          onClick={() => handleRequestStatus(request._id, 'Approved')}
                                        >
                                          Approve
                                        </button>
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={() => handleRequestStatus(request._id, 'Rejected')}
                                        >
                                          Reject
                                        </button>
                                      </>
                                    ) : (
                                      <p
                                        className={`badge ${
                                          request.status === 'Rejected' ? 'bg-danger' : 'bg-success'
                                        }`}
                                      >
                                        {request.status}
                                      </p>
                                    )}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="text-muted">No requests for today.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6 col-sm-12">
                    <div className="card booking">
                      <div className="card-body flex flex-col gap-y-4">
                        <p className="fs-4 fw-bold">Financial Management</p>
                        <div className="row">
                          <div className="col-6">
                            <p>
                              <strong>Total Revenue:</strong> ₹
                              {dummyFinancialData.totalRevenue}
                            </p>
                            <p>
                              <strong>Total Expenses:</strong> ₹
                              {dummyFinancialData.totalExpenses}
                            </p>
                          </div>
                          <div className="col-6">
                            <p>
                              <strong>Net Profit:</strong> ₹
                              {dummyFinancialData.netProfit}
                            </p>
                          </div>
                        </div>
                        <BarChart1
                          labels={dummyFinancialData.monthly.labels}
                          datasets={dummyFinancialData.monthly.datasets}
                        />
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="col-md-6 col-sm-12">
                    <div className="card booking">
                      <div className="card-body">
                        <p className="fs-4 fw-bold">
                          Sales for{" "}
                          {currentMonth.toLocaleDateString("default", {
                            month: "long",
                            year: "numeric",
                          })}
                        </p>
                        <Calendar
                          onActiveStartDateChange={({ activeStartDate }) =>
                            console.log(activeStartDate)
                          }
                          tileContent={renderTileContent}
                          showNavigation={true}
                          showNeighboringMonth={false}
                          value={new Date()} // Default to today's date
                        />
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-6 col-sm-12">
                    <div className="card booking">
                      <div className="card-body">
                        <p className="fs-4 fw-bold">Feedback on recent bookings</p>
                        <table className="w-full text-lg text-center gap-x-3">
                          <tr className="w-full flex flex-row justify-between">
                            <th className="w-full">Customer Name</th>
                            <th className="w-full">Feedback</th>
                            <th className="w-full">Rating</th>
                          </tr>
                          <div className="no-scrollbar w-full" style={{ maxHeight: '30rem', overflowY: 'auto' }}>
                            {recentFeedback?.length > 0 ? (
                              recentFeedback.map((feedback, i) => (
                                <tr className="w-full flex flex-row justify-between my-4 items-center" key={i}>
                                  <td className="w-full">{feedback?.customer?.name || 'Anonymous user'}</td>
                                  <td className="w-full">{feedback?.feedback || 'No feedback provided'}</td>
                                  <td className="w-full">
                                    <ReactStars count={5} value={feedback?.rating || 0} size={24} color2={'#ffd700'} />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  style={{ paddingLeft: '20px', fontSize: '14px' }}
                                  colSpan="3"
                                  className="text-center"
                                >
                                  No feedbacks
                                </td>
                              </tr>
                            )}
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-xl-6 col-sm-12">
                    <div className="card booking">
                      <div className="card-body">
                        <p className="font-semibold text-lg">Completed Bookings:</p>
                        <ChartPie
                          completedPkgColor="green"
                          pendingPkgColor="orange"
                          remainingPkgColor="#e5e7eb"
                          packageData={[
                            stats?.tourBookingStats?.totalTour || 0, // Completed Packages
                            stats?.tourBookingStats?.totalHotel || 0, // Pending Packages
                            stats?.tourBookingStats?.totalFlight || 0, //Total Packages
                          ]}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-12">
                    <div className="card booking">
                      <div className="card-body">
                        <p className="font-semibold text-lg">Monthly Bookings:</p>
                        <BarChart1 labels={bookingDetails.labels} datasets={bookingDetails.datasets} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body p-0">
                      <Tab.Content>
                        <Tab.Pane eventKey="All" active show>
                          <div className="table-responsive">
                            <div id="room_wrapper" className="dataTables_wrapper no-footer">
                              <table className="table card-table display mb-4 dataTablesCard booking-table room-list-tbl dataTable no-footer">
                                <thead>
                                  <tr>
                                    <th>Customer Name</th>
                                    <th>Hotel</th>
                                    <th>Flight</th>
                                    <th>Tour</th>
                                    <th>Booking Date</th>

                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(bookings) && bookings.length > 0 ? (
                                    bookings.map((booking) => (
                                      <tr key={booking._id} className="text-center align-middle">
                                        <td>{booking.customer?.name || 'N/A'}</td>
                                        <td>{booking.hotel?.name || 'N/A'}</td>
                                        <td>{booking?.flightName || 'N/A'}</td>
                                        <td>{booking?.tour?.name || 'N/A'}</td>

                                        <td>{moment(booking.bookingTime).format('MMM DD, YYYY')}</td>

                                        <td className="text-start">{renderStatusBadge(booking.status)}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="8" className="text-center py-3">
                                        No bookings found.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              {bookings.length > 0 && (
                                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                                  <div className="dataTables_info">
                                    Showing {(page - 1) * limit + 1} to {Math.min(page * limit, totalEntries)} of{' '}
                                    {totalEntries} entries
                                  </div>
                                  <div className="dataTables_paginate paging_simple_numbers mb-0">
                                    <Link
                                      className={`paginate_button previous ${page === 1 ? 'disabled' : ''}`}
                                      onClick={() => page > 1 && setPage(page - 1)}
                                    >
                                      <i className="fa fa-angle-double-left"></i> Previous
                                    </Link>
                                    <span>
                                      {[...Array(totalPages)].map((_, i) => (
                                        <Link
                                          key={i}
                                          className={`paginate_button ${page === i + 1 ? 'current' : ''}`}
                                          onClick={() => setPage(i + 1)}
                                        >
                                          {i + 1}
                                        </Link>
                                      ))}
                                    </span>
                                    <Link
                                      className={`paginate_button next ${page === totalPages ? 'disabled' : ''}`}
                                      onClick={() => page < totalPages && setPage(page + 1)}
                                    >
                                      Next <i className="fa fa-angle-double-right"></i>
                                    </Link>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ManageBookingModal show={showBookingModal} handleClose={handleCloseBookingModal} bookings={dummyBookings} />
    </>
  );
};

export default Dashboard;
